import { c as _c } from "react/compiler-runtime";
import { Center, Spinner } from '@chakra-ui/react';
import { onboardingNavItems } from '@src/components/sco/Onboarding/Layout/OnboardingNav';
import { SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useParams, usePathname, useRouter } from 'next/navigation';
import React, { createContext, FC, useContext, useEffect, useMemo, useState } from 'react';
type OnboardingContextValue = {
  children?: React.ReactNode;
  breadcrumbs?: {
    title: string;
    href: string;
  }[];
  redirectUnauthenticated?: boolean;
  navItems?: SidebarNestedNavListSection[];
  nextStepHref?: string;
  setBreadcrumbs?: (breadcrumbs: OnboardingContextValue['breadcrumbs']) => void;
};
export const OnboardingContext = createContext<OnboardingContextValue>({});
export const useOnboardingContext = () => {
  return useContext(OnboardingContext);
};
export const OnboardingContextProvider: FC<OnboardingContextValue> = props => {
  const $ = _c(18);
  const {
    currentUser
  } = useCurrentUser();
  const router = useRouter();
  const pathname = usePathname();
  const routeParams = useParams();
  const [activeContentTrackEnrollmentId, setActiveContentTrackEnrollmentId] = useState(routeParams?.contentTrackEnrollmentId as string);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      title: "Onboarding",
      href: "/onboarding"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [breadcrumbs, setBreadcrumbs] = useState(t0);
  let t1;
  if (props.navItems) {
    t1 = props.navItems;
  } else {
    t1 = onboardingNavItems;
  }
  const navItems = t1;
  const activeStepIndex = navItems.findIndex(i => pathname?.startsWith(i.href));
  const nextStepHref = navItems[activeStepIndex + 1]?.href || "/";
  let t2;
  if ($[1] !== activeContentTrackEnrollmentId || $[2] !== breadcrumbs || $[3] !== nextStepHref || $[4] !== props.redirectUnauthenticated) {
    t2 = {
      activeContentTrackEnrollmentId,
      breadcrumbs,
      setActiveContentTrackEnrollmentId,
      setBreadcrumbs,
      nextStepHref,
      redirectUnauthenticated: props.redirectUnauthenticated
    };
    $[1] = activeContentTrackEnrollmentId;
    $[2] = breadcrumbs;
    $[3] = nextStepHref;
    $[4] = props.redirectUnauthenticated;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const contextValue = t2;
  let t3;
  if ($[6] !== currentUser?.isGuest || $[7] !== pathname || $[8] !== props.redirectUnauthenticated || $[9] !== router) {
    t3 = () => {
      if (props.redirectUnauthenticated !== false && currentUser?.isGuest) {
        router.push(`/login?returnTo=${pathname}`);
      }
    };
    $[6] = currentUser?.isGuest;
    $[7] = pathname;
    $[8] = props.redirectUnauthenticated;
    $[9] = router;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = currentUser?.isGuest;
  let t5;
  if ($[11] !== props.redirectUnauthenticated || $[12] !== t4) {
    t5 = [t4, props.redirectUnauthenticated];
    $[11] = props.redirectUnauthenticated;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t3, t5);
  if (!currentUser || currentUser?.isGuest && props.redirectUnauthenticated !== false) {
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Center padding="1em"><Spinner /></Center>;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  let t6;
  if ($[15] !== contextValue || $[16] !== props.children) {
    t6 = <OnboardingContext.Provider value={contextValue}>{props.children}</OnboardingContext.Provider>;
    $[15] = contextValue;
    $[16] = props.children;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};